module.exports = __webpack_public_path__ + "img/room10.35706cc0.gif";